import api from './api';

export interface Contact {
  id: number;
  userId?: number | null;
  name: string;
  email: string;
  company?: string | null;
  phone?: string | null;
  subject: 'general' | 'technical' | 'billing' | 'bug' | 'feature' | 'other';
  message: string;
  status: 'pending' | 'in_progress' | 'resolved' | 'closed';
  adminNotes?: string | null;
  respondedAt?: string | null;
  createdAt: string;
  updatedAt: string;
  user?: {
    id: number;
    username: string;
    firstName: string;
    lastName: string;
  } | null;
}

export interface ContactListResponse {
  success: boolean;
  data: Contact[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const contactService = {
  async create(data: {
    name: string;
    email: string;
    company?: string | null;
    phone?: string | null;
    subject: 'general' | 'technical' | 'billing' | 'bug' | 'feature' | 'other';
    message: string;
  }): Promise<{ success: boolean; data: Contact; message: string }> {
    const response = await api.post('/contacts', data);
    return response.data;
  },

  async list(params?: {
    page?: number;
    limit?: number;
    status?: string;
    subject?: string;
  }): Promise<ContactListResponse> {
    const response = await api.get('/contacts', { params });
    return response.data;
  },

  async getById(id: number): Promise<{ success: boolean; data: Contact }> {
    const response = await api.get(`/contacts/${id}`);
    return response.data;
  },

  async update(id: number, data: {
    status?: 'pending' | 'in_progress' | 'resolved' | 'closed';
    adminNotes?: string | null;
  }): Promise<{ success: boolean; data: Contact }> {
    const response = await api.put(`/contacts/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/contacts/${id}`);
  },
};

